import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getModHandler } from "@src/store/slices/experienceBuilder/common/utils/modHandlerRegistry";

export const hasModChanges = (
  a: EmbeddedMod | undefined,
  b: EmbeddedMod | undefined
) => {
  if (!a) {
    return Boolean(b);
  }
  if (!b) {
    return Boolean(a);
  }
  if (a.type !== b.type) {
    return true;
  }
  return getModHandler(a).hasChanges(a, b);
};
